import script from "./SubHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubHeader.vue?vue&type=script&setup=true&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=21a2bff1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a2bff1"]])

export default __exports__